module.exports = __webpack_public_path__ + "static/media/undraw_financial_data_es63_red.691f8fbd.svg";